var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"widgets--list",class:{'icon-loading': _vm.loading }},_vm._l((_vm.displayedReferences),function(reference){return _c('div',{key:reference?.openGraphObject?.id},[_c('NcReferenceWidget',{attrs:{"reference":reference}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }